function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useEffect } from 'react';
import { DEFAULT_TABLET_VIEW_MODE, TABLET_VIEW_MODE_KEY } from '@edusense/shared-constants';
/**
 * 태블릿 뷰 모드 설정을 관리하는 hook
 * localStorage에 사용자 프리퍼런스를 저장하고 불러옴
 */ export var useTabletViewMode = function(options) {
    var defaultMode = (options === null || options === void 0 ? void 0 : options.defaultMode) || DEFAULT_TABLET_VIEW_MODE;
    var _useState = _sliced_to_array(useState(defaultMode), 2), viewMode = _useState[0], setViewMode = _useState[1];
    // localStorage에서 뷰 모드 불러오기
    useEffect(function() {
        try {
            var savedMode = localStorage.getItem(TABLET_VIEW_MODE_KEY);
            if (savedMode && [
                'sidebar-default',
                'content-focused',
                'balanced'
            ].includes(savedMode)) {
                setViewMode(savedMode);
            } else {
                // 저장된 값이 없거나 유효하지 않으면 기본값 사용
                setViewMode(defaultMode);
            }
        } catch (error) {
            console.warn('Failed to load tablet view mode from localStorage:', error);
            setViewMode(defaultMode);
        }
    }, [
        defaultMode
    ]);
    // 뷰 모드 변경 함수
    var changeViewMode = function(newMode) {
        try {
            setViewMode(newMode);
            localStorage.setItem(TABLET_VIEW_MODE_KEY, newMode);
        } catch (error) {
            console.error('Failed to save tablet view mode to localStorage:', error);
        }
    };
    return {
        viewMode: viewMode,
        changeViewMode: changeViewMode,
        isDefault: viewMode === DEFAULT_TABLET_VIEW_MODE
    };
};
